import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';

const items = Routes.filter((r) => r.showInNavigation && r.path.startsWith('/explore/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.Search].path]: MagnifyingGlassIcon,
};

export function ExploreSidebar() {
  return items.length > 0 ? <Sidebar label="Explore" items={items} iconMap={iconMap} depth={1} /> : null;
}
